// import external dependencies
// import 'jquery';

import 'slick-carousel';

import { Header } from './blocks/header.js';
import { MegaMenuTabs } from './blocks/megaMenuTabs.js';
import AnimateOnScroll from './components/animateOnScroll.js';
import BlogLobby from './routes/blogLobby.js';
import Hero from './blocks/hero.js';
import LottieAnimation from './components/lottie-animation.js';
import ResourcesLobby from './routes/resourcesLobby.js';
import Root from './components/root.js';
import Video from './components/video.js';

// Self-executing critical functionality
// This file is enqueued as a standalone entrypoint, so we instantiate immediately
const initCritical = () => {
  new Header().initialize();
  new MegaMenuTabs();
  new Root();
  new AnimateOnScroll().bootstrap();
  if (document.querySelector('.section-blog-lobby')) {
    new BlogLobby().bootstrap();
  }
  if (document.querySelector('.section-resources-lobby')) {
    new ResourcesLobby().bootstrap();
  }
  new Hero();
  new LottieAnimation();
  new Video();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCritical);
} else {
  initCritical();
}



// WEBPACK FOOTER //
// ./scripts/critical.js